import React from "react";
import ReactHtmlParser from "react-html-parser";
import InitialButton from "../InitialButton";

const StartQuiz = ({ data, onClick, title }) => {
  const {
    content: { rendered },
    new_attempt_allwed,
    attempts_error,
  } = data;

  return new_attempt_allwed ? (
    <React.Fragment>
      <div className="startQuestion">
        {ReactHtmlParser(rendered)}
        <InitialButton onClick={onClick} title={title} />
      </div>
    </React.Fragment>
  ) : (
    <p>{attempts_error}</p>
  );
};

export default StartQuiz;
